'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.http = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib


// Utils


// Interceptors


var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _logger = require('../../logger');

var _logger2 = _interopRequireDefault(_logger);

var _getClientConfig = require('../../getClientConfig');

var _getClientConfig2 = _interopRequireDefault(_getClientConfig);

var _requestAuthorisationInterceptor = require('./requestAuthorisationInterceptor');

var _requestAuthorisationInterceptor2 = _interopRequireDefault(_requestAuthorisationInterceptor);

var _responseRetryInterceptor = require('../../../../common/utils/http/responseRetryInterceptor');

var _responseRetryInterceptor2 = _interopRequireDefault(_responseRetryInterceptor);

var _httpConstants = require('../../../../common/utils/http/httpConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var clientConfig = (0, _getClientConfig2.default)();
var apiRootUrl = clientConfig.apiRoot || '';

// Constants


var DEFAULT_CONFIG = {
    method: _httpConstants.METHODS.GET,
    timeout: 2000,
    responseType: 'json',
    prefix: apiRootUrl + '/api'
};

// Request interceptors
_axios2.default.interceptors.request.use(_requestAuthorisationInterceptor2.default);

// Response interceptors
var retryErrorCb = function retryErrorCb(err) {
    return _logger2.default.warn('RETRYING: A http error occurred (' + (err.config.retry - err.config._retryCount) + ' ' + 'attempts remaining)', err, err.response, JSON.stringify(err));
};
_axios2.default.interceptors.response.use(undefined, (0, _responseRetryInterceptor2.default)(_axios2.default, retryErrorCb));

var http = exports.http = function http(config) {
    var axiosConfig = _extends({}, DEFAULT_CONFIG, config);
    axiosConfig.url = axiosConfig.prefix + '/' + config.url;

    return (0, _axios2.default)(axiosConfig);
};


//////////////////
// WEBPACK FOOTER
// ./src/client/utils/services/http/http.js
// module id = 2133
// module chunks = 0